import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Switch from "react-switch";
import Loading from "../general/Loading.js";
import Search from "../general/Search.js";
import DateTd from "../table-componets/DateTd.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import { DATE } from "../../utils/dateFormats";
import { toastrApiErrors } from "../../utils/errors";


const ModuleToggleAndExpirationDate = props => {
  const {
    title,
    toggleValue,
    toggleName,
    expirationDateName,
    toggleColumn
  } = props;

  return (
    <div className="row">
      <div className="col-xs-12 col-md-6">
        <label>{title}</label>
        <br />
        <Switch
          checked={toggleValue}
          onChange={(e) => toggleColumn(e, toggleName)}
          onColor="#DADCE1"
          onHandleColor="#3A4590"
          handleDiameter={25}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={48}
          className="react-switch"
          id="material-switch"
        />
      </div>
      <div className="col-xs-12 col-md-6">
        <label className="float-right">*Expiration Date</label>
        <br />
        <input
          id={expirationDateName}
          className="full-width"
        />
      </div>
    </div>
  )
};

class Admin extends React.Component {
  state = {
    searchText: "",
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "id",
    orderDir: "DESC",
    loading: true,
    userOverLimitAccounts: false,
    dStarAccounts: false,
    showArchived: false,
    accounts: [],
    selectedAccount: {},
    trialExpirationDate: null,
    paymentDueDate: null,
    activeUserLimit: 0,
    schedulingModuleExpDate: null,
    timeClocksModuleExpDate: null,
    certificationsModuleExpDate: null,
    inServicesModuleExpDate: null,
    shiftReportsModuleExpDate: null,
    customFormsModuleExpDate: null,
    checklistsModuleExpDate: null,
    chemicalRecordsModuleExpDate: null,
    slideInspectionsModuleExpDate: null,
    patronCountsModuleExpDate: null,
    groupLessonsModuleExpDate: null,
    privateLessonsModuleExpDate: null,
    memberManagementModuleExpDate: null,
    digichatModuleExpDate: null,
    schedulingToggle: false,
    chemicalRecordsToggle: false,
    memberManagementToggle: false,
    privateLessonsToggle: false,
    groupLessonsToggle: false,
    showStarfishProgram: false,
    showPadiProgram: false,
    isSai: false,
    customFormsToggle: false,
    inServicesToggle: false,
    patronCountsToggle: false,
    checklistsToggle: false,
    shiftReportsToggle: false,
    certificationsToggle: false,
    slideInspectionsToggle: false,
    timeClocksToggle: false,
    digichatToggle: false,
    jotformUrl: "",
    accessTokenView: false,
    accessTokens: []
  };

  componentDidMount() {
    this.buildData();
  }

  buildData() {
    const fields = [
      "id",
      "created_at",
      "name",
      "trial",
      "trial_expires_on",
      "payment_due_at",
      "active_user_limit",
      "remaining_active_users",
      "archived",
      "scheduling_toggle",
      "chemical_records_toggle",
      "member_management_toggle",
      "private_lessons_toggle",
      "group_lessons_toggle",
      "show_starfish_program",
      "show_padi_program",
      "custom_forms_toggle",
      "in_services_toggle",
      "patron_counts_toggle",
      "checklists_toggle",
      "shift_reports_toggle",
      "certifications_toggle",
      "slide_inspections_toggle",
      "time_clocks_toggle",
      "digichat_toggle",
      "jotform_url",
      "is_sai",
      "scheduling_module_exp_date",
      "time_clocks_module_exp_date",
      "certifications_module_exp_date",
      "in_services_module_exp_date",
      "shift_reports_module_exp_date",
      "custom_forms_module_exp_date",
      "checklists_module_exp_date",
      "chemical_records_module_exp_date",
      "slide_inspections_module_exp_date",
      "patron_counts_module_exp_date",
      "group_lessons_module_exp_date",
      "private_lessons_module_exp_date",
      "member_management_module_exp_date",
      "digichat_module_exp_date"
    ];

    const that = this;
    const params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
      user_over_limit_accounts: this.state.userOverLimitAccounts,
      d_star_accounts: this.state.dStarAccounts,
      archived: this.state.showArchived,
      only: fields.join(","),
    };

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }

    axios({
      method: "get",
      url: "/accounts.json",
      params: params,
      responseType: "json",
    }).then(function (response) {
      that.setState({ loading: false });
      that.setState({ accounts: response.data });
      that.setState({
        totalPages: Math.ceil(response.headers.total / that.state.perPage),
      });
    });

    axios({
      method: "get",
      url: "/access_tokens.json",
      responseType: "json",
    }).then(function (response) {
      that.setState({ accessTokens: response.data });
    });
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch });
    this.setState({ page: 1 });
    this.buildData();
  }

  sortData(orderBy, orderDir = "DESC") {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: orderDir });
    }

    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  renderPagination() {
    return (
      <div>
        <p>
          {"Showing page " + this.state.page + " of " + this.state.totalPages}
        </p>
        {this.state.page == 1 && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page != 1 && (
          <a className="btn btn-default" onClick={() => this.changePage(-1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page < this.state.totalPages && (
          <a className="btn btn-default" onClick={() => this.changePage(1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
        {this.state.page == this.state.totalPages && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
      </div>
    );
  }

  activateAccount(account, index) {
    var that = this;

    if (
      confirm("Are you sure you want to activate" + account.name + "?") == true
    ) {
      axios
        .post(`/accounts/${account.id}/activate.json`)
        .then(function (response) {
          var accounts = that.state.accounts;
          accounts[index] = response.data;
          that.setState({ accounts: accounts });
          toastr.success("Account activated");
        })
        .catch(function (error) {
          toastr.error("Account not activated");
          console.log(error);
        });
    }
  }

  openEditModal(account, index) {
    var that = this;

    var accounts = this.state.accounts;

    if (account.trial_expires_on) {
      var trialExpirationDate = moment(account.trial_expires_on).format();
    } else {
      var trialExpirationDate = null;
    }

    $("#editTrialExpirationDate").kendoDatePicker({
      value: trialExpirationDate,

      change: function (e) {
        var value = e.sender.value();

        that.setState({
          trialExpirationDate: value,
        });
      },
    });

    if (account.payment_due_at) {
      var paymentDueDate = moment(account.payment_due_at).format();
    } else {
      var paymentDueDate = null;
    }

    $("#editPaymentDueDate").kendoDatePicker({
      value: paymentDueDate,

      change: function (e) {
        var value = e.sender.value();

        that.setState({
          paymentDueDate: value,
        });
      },
    });

    var schedulingModuleExpDate = account.scheduling_module_exp_date ? moment(account.scheduling_module_exp_date).format() : null;
    $("#editSchedulingModuleExpDate").kendoDatePicker({
      value: schedulingModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          schedulingModuleExpDate: value
        });
      }
    });

    var timeClocksModuleExpDate = account.time_clocks_module_exp_date ? moment(account.time_clocks_module_exp_date).format() : null;
    $("#editTimeClocksModuleExpDate").kendoDatePicker({
      value: timeClocksModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          timeClocksModuleExpDate: value
        });
      }
    });

    var certificationsModuleExpDate = account.certifications_module_exp_date ? moment(account.certifications_module_exp_date).format() : null;
    $("#editCertificationsModuleExpDate").kendoDatePicker({
      value: certificationsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          certificationsModuleExpDate: value
        });
      }
    });

    var inServicesModuleExpDate = account.in_services_module_exp_date ? moment(account.in_services_module_exp_date).format() : null;
    $("#editinServicesModuleExpDate").kendoDatePicker({
      value: inServicesModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          inServicesModuleExpDate: value
        });
      }
    });

    var shiftReportsModuleExpDate = account.shift_reports_module_exp_date ? moment(account.shift_reports_module_exp_date).format() : null;
    $("#editShiftReportsModuleExpDate").kendoDatePicker({
      value: shiftReportsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          shiftReportsModuleExpDate: value
        });
      }
    });

    var customFormsModuleExpDate = account.custom_forms_module_exp_date ? moment(account.custom_forms_module_exp_date).format() : null;
    $("#editCustomFormsModuleExpDate").kendoDatePicker({
      value: customFormsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          customFormsModuleExpDate: value
        });
      }
    });

    var checklistsModuleExpDate = account.checklists_module_exp_date ? moment(account.checklists_module_exp_date).format() : null;
    $("#editchecklistsModuleExpDate").kendoDatePicker({
      value: checklistsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          checklistsModuleExpDate: value
        });
      }
    });

    var chemicalRecordsModuleExpDate = account.chemical_records_module_exp_date ? moment(account.chemical_records_module_exp_date).format() : null;
    $("#editChemicalRecordsModuleExpDate").kendoDatePicker({
      value: chemicalRecordsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          chemicalRecordsModuleExpDate: value
        });
      }
    });

    var slideInspectionsModuleExpDate = account.slide_inspections_module_exp_date ? moment(account.slide_inspections_module_exp_date).format() : null;
    $("#editslideInspectionsModuleExpDate").kendoDatePicker({
      value: slideInspectionsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          slideInspectionsModuleExpDate: value
        });
      }
    });

    var patronCountsModuleExpDate = account.patron_counts_module_exp_date ? moment(account.patron_counts_module_exp_date).format() : null;
    $("#editPatronCountsModuleExpDate").kendoDatePicker({
      value: patronCountsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          patronCountsModuleExpDate: value
        });
      }
    });

    var groupLessonsModuleExpDate = account.group_lessons_module_exp_date ? moment(account.group_lessons_module_exp_date).format() : null;
    $("#editGroupLessonsModuleExpDate").kendoDatePicker({
      value: groupLessonsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          groupLessonsModuleExpDate: value
        });
      }
    });

    var privateLessonsModuleExpDate = account.private_lessons_module_exp_date ? moment(account.private_lessons_module_exp_date).format() : null;
    $("#editprivateLessonsModuleExpDate").kendoDatePicker({
      value: privateLessonsModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          privateLessonsModuleExpDate: value
        });
      }
    });

    var memberManagementModuleExpDate = account.member_management_module_exp_date ? moment(account.member_management_module_exp_date).format() : null;
    $("#editMemberManagementModuleExpDate").kendoDatePicker({
      value: memberManagementModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          memberManagementModuleExpDate: value
        });
      }
    });

    var digichatModuleExpDate = account.digichat_module_exp_date ? moment(account.digichat_module_exp_date).format() : null;
    $("#editDigichatModuleExpDate").kendoDatePicker({
      value: digichatModuleExpDate,

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          digichatModuleExpDate: value
        });
      }
    });

    account.index = index;
    this.setState({ selectedAccount: account });
    this.setState({ trialExpirationDate: account.trial_expires_on });
    this.setState({ paymentDueDate: account.payment_due_at });
    this.setState({ activeUserLimit: account.active_user_limit });
    this.setState({ schedulingToggle: account.scheduling_toggle });
    this.setState({ chemicalRecordsToggle: account.chemical_records_toggle });
    this.setState({ memberManagementToggle: account.member_management_toggle });
    this.setState({ privateLessonsToggle: account.private_lessons_toggle });
    this.setState({ groupLessonsToggle: account.group_lessons_toggle });
    this.setState({ showStarfishProgram: account.show_starfish_program });
    this.setState({ showPadiProgram: account.show_padi_program });
    this.setState({ isSai: account.is_sai });
    this.setState({ customFormsToggle: account.custom_forms_toggle });
    this.setState({ inServicesToggle: account.in_services_toggle });
    this.setState({ patronCountsToggle: account.patron_counts_toggle });
    this.setState({ checklistsToggle: account.checklists_toggle });
    this.setState({ shiftReportsToggle: account.shift_reports_toggle });
    this.setState({ certificationsToggle: account.certifications_toggle });
    this.setState({ slideInspectionsToggle: account.slide_inspections_toggle });
    this.setState({ timeClocksToggle: account.time_clocks_toggle });
    this.setState({ chemicalRecordsToggle: account.chemical_records_toggle });
    this.setState({ digichatToggle: account.digichat_toggle });
    this.setState({ jotformUrl: account.jotform_url ? account.jotform_url : "" });
    this.setState({ schedulingModuleExpDate: account.scheduling_module_exp_date });
    this.setState({ timeClocksModuleExpDate: account.time_clocks_module_exp_date });
    this.setState({ certificationsModuleExpDate: account.certifications_module_exp_date });
    this.setState({ inServicesModuleExpDate: account.in_services_module_exp_date });
    this.setState({ shiftReportsModuleExpDate: account.shift_reports_module_exp_date });
    this.setState({ customFormsModuleExpDate: account.custom_forms_module_exp_date });
    this.setState({ checklistsModuleExpDate: account.checklists_module_exp_date });
    this.setState({ chemicalRecordsModuleExpDate: account.chemical_records_module_exp_date });
    this.setState({ slideInspectionsModuleExpDate: account.slide_inspections_module_exp_date });
    this.setState({ patronCountsModuleExpDate: account.patron_counts_module_exp_date });
    this.setState({ groupLessonsModuleExpDate: account.group_lessons_module_exp_date });
    this.setState({ privateLessonsModuleExpDate: account.private_lessons_module_exp_date });
    this.setState({ memberManagementModuleExpDate: account.member_management_module_exp_date });
    this.setState({ digichatModuleExpDate: account.digichat_module_exp_date });
    $("#editAccountModal").modal("show");
  }

  archiveAccount(account, index) {
    var that = this;

    if (
      confirm("Are you sure you want to archive " + account.name + "?") == true
    ) {
      axios
        .put("/accounts/" + account.id + ".json", {
          account: { archived: true },
        })
        .then(function (response) {
          var accounts = that.state.accounts;
          accounts.splice(index, 1);
          that.setState({ accounts: accounts });
          toastr.success("Account archived");
        })
        .catch(function (error) {
          toastr.error("Account not archived");
          console.log(error);
        });
    }
  }

  setAccount(accountId) {
    var that = this;

    axios
      .post("/change_account/", { account_id: accountId })
      .then(function (response) {
        toastr.success("Account changed");
        setTimeout(
          function () {
            window.location.href = "/users";
          }.bind(this),
          300
        );
      })
      .catch(function (error) {
        toastr.error("Account not changed");
        console.log(error);
      });
  }

  saveAccount() {
    var that = this;
    axios
      .put("/accounts/" + that.state.selectedAccount.id + ".json", {
        account: {
          trial_expires_on: that.state.trialExpirationDate,
          payment_due_at: that.state.paymentDueDate,
          active_user_limit: that.state.activeUserLimit,
          scheduling_toggle: that.state.schedulingToggle,
          chemical_records_toggle: that.state.chemicalRecordsToggle,
          member_management_toggle: that.state.memberManagementToggle,
          private_lessons_toggle: that.state.privateLessonsToggle,
          group_lessons_toggle: that.state.groupLessonsToggle,
          show_starfish_program: that.state.showStarfishProgram,
          show_padi_program: that.state.showPadiProgram,
          is_sai: that.state.isSai,
          custom_forms_toggle: that.state.customFormsToggle,
          in_services_toggle: that.state.inServicesToggle,
          patron_counts_toggle: that.state.patronCountsToggle,
          checklists_toggle: that.state.checklistsToggle,
          shift_reports_toggle: that.state.shiftReportsToggle,
          certifications_toggle: that.state.certificationsToggle,
          slide_inspections_toggle: that.state.slideInspectionsToggle,
          time_clocks_toggle: that.state.timeClocksToggle,
          digichat_toggle: that.state.digichatToggle,
          jotform_url: that.state.jotformUrl,
          scheduling_module_exp_date: that.state.schedulingModuleExpDate,
          time_clocks_module_exp_date: that.state.timeClocksModuleExpDate,
          certifications_module_exp_date: that.state.certificationsModuleExpDate,
          in_services_module_exp_date: that.state.inServicesModuleExpDate,
          shift_reports_module_exp_date: that.state.shiftReportsModuleExpDate,
          custom_forms_module_exp_date: that.state.customFormsModuleExpDate,
          checklists_module_exp_date: that.state.checklistsModuleExpDate,
          chemical_records_module_exp_date: that.state.chemicalRecordsModuleExpDate,
          slide_inspections_module_exp_date: that.state.slideInspectionsModuleExpDate,
          patron_counts_module_exp_date: that.state.patronCountsModuleExpDate,
          group_lessons_module_exp_date: that.state.groupLessonsModuleExpDate,
          private_lessons_module_exp_date: that.state.privateLessonsModuleExpDate,
          member_management_module_exp_date: that.state.memberManagementModuleExpDate,
          digichat_module_exp_date: that.state.digichatModuleExpDate
        },
      })
      .then(function (response) {
        var accounts = that.state.accounts;
        accounts[that.state.selectedAccount.index] = response.data;
        that.setState({ accounts: accounts });
        $("#editAccountModal").modal("hide");
        var trialExpirationDate = $("#editTrialExpirationDate").data(
          "kendoDatePicker"
        );
        var paymentDueDate = $("#editPaymentDueDate").data("kendoDatePicker");
        trialExpirationDate.value(null);
        paymentDueDate.value(null);
        toastr.success("Account updated");
      })
      .catch(function (error) {
        toastrApiErrors(error, "Unable to update Account");
      });
  }

  toggleColumn = (e, column) => {
    var that = this;
    that.setState({ [column]: e });
  };

  activeUsers = (account) => {
    return `${account.active_user_count} / ${account.active_user_limit}`;
  };

  isUserOverLimit = (account) => {
    if (account.active_user_limit === 0) return false;

    return account.active_user_count >= account.active_user_limit;
  };

  handleUserOverLimitAccountFilter = () => {
    this.setState({ loading: true });
    this.setState({ page: 1 });
    this.setState(
      (prevState) => ({
        userOverLimitAccounts: !prevState.userOverLimitAccounts,
      }),
      this.buildData
    );
  };

  handleDStarAccountFilter = () => {
    this.setState({ loading: true });
    this.setState({ page: 1 });
    this.setState(
      (prevState) => ({
        dStarAccounts: !prevState.dStarAccounts,
      }),
      this.buildData
    );
  };

  handleShowArchivedFilter = () => {
    this.setState({ loading: true });
    this.setState({ page: 1 });
    this.setState(
      (prevState) => ({
        showArchived: !prevState.showArchived,
      }),
      this.buildData
    );
  };

  restoreAccount(account, index) {
    var that = this;

    if (
      confirm("Are you sure you want to restore " + account.name + "?") == true
    ) {
      axios
        .put("/accounts/" + account.id + ".json", {
          account: { archived: false },
        })
        .then(function (response) {
          var accounts = that.state.accounts;
          accounts.splice(index, 1);
          that.setState({ accounts: accounts });
          toastr.success("Account restored");
        })
        .catch(function (error) {
          toastr.error("Account not restored");
          console.log(error);
        });
    }
  }

  renderBody() {
    var that = this;
    var accounts = [];

    _.forEach(this.state.accounts, function (account, index) {
      var expired = moment(account.trial_expires_on).isBefore(moment());
      var paymentDueDatePresent = moment(account.payment_due_at).isValid();

      accounts.push(
        <tr key={index}>
          <GeneralTd
            fieldValue={account.id}
            fieldClassName="hidden-xs hidden-sm"
          />
          <GeneralTd fieldValue={account.name} />
          <DateTd
            fieldValue={account.created_at}
            fieldFormat={DATE}
            fieldClassName="hidden-xs hidden-sm"
          />
          <td>
            {account.trial ? (
              <a
                className="btn btn-indigo"
                onClick={function () {
                  that.activateAccount(account, index);
                }}
              >
                ACTIVATE
              </a>
            ) : (
              "-"
            )}
          </td>
          <td className="hidden-xs hidden-sm">
            {account.trial && expired && (
              <b className="pink-text">
                {moment(account.trial_expires_on).format(DATE)}
              </b>
            )}
            {account.trial && !expired && (
              <span>{moment(account.trial_expires_on).format(DATE)}</span>
            )}
            {!account.trial && <span>-</span>}
          </td>
          <td className="hidden-xs hidden-sm">
            {paymentDueDatePresent && (
              <span>{moment(account.payment_due_at).format(DATE)}</span>
            )}
            {!paymentDueDatePresent && <span>-</span>}
          </td>

          {that.isUserOverLimit(account) ? (
            <GeneralTd
              fieldValue={that.activeUsers(account)}
              fieldClassName={"hidden-xs hidden-sm pink-text"}
            />
          ) : (
            <GeneralTd
              fieldValue={that.activeUsers(account)}
              fieldClassName={"hidden-xs hidden-sm"}
            />
          )}
          <td className="hidden-xs hidden-sm">
            {that.state.showArchived ? (
              <a
                className="btn btn-text pull-right"
                onClick={function () {
                  that.restoreAccount(account, index);
                }}
              >
                RESTORE
              </a>
            ) : (
              <a
                className="btn btn-text pull-right"
                onClick={function () {
                  that.archiveAccount(account, index);
                }}
              >
                ARCHIVE
              </a>
            )}
          </td>
          <td>
            <a
              className="btn btn-text pull-right"
              onClick={function () {
                that.openEditModal(account, index);
              }}
            >
              EDIT
            </a>
          </td>
          <td>
            <a
              className="btn btn-text pull-right"
              onClick={function () {
                that.setAccount(account.id);
              }}
            >
              GOTO
            </a>
          </td>
        </tr>
      );
    });

    return <tbody>{accounts}</tbody>;
  }

  toggleAccessTokenView() {
    this.setState({ accessTokenView: !this.state.accessTokenView })
  };

  createAccessToken() {
    var that = this;
    axios
      .post("/access_tokens.json", {})
      .then(function (response) {
        var accessTokens = that.state.accessTokens;
        accessTokens.unshift(response.data);
        that.setState({ accessTokens: accessTokens });
        toastr.success("Access Token Created");
      })
      .catch(function (error) {
        toastr.error("ERROR Access Token Not Created");
        console.log(error);
      });
  };

  destroyAccessToken(accessTokenId) {
    var that = this;
    axios
      .delete("/access_tokens/" + accessTokenId + ".json", {})
      .then(function (response) {
        var accessTokens = that.state.accessTokens;
        accessTokens = accessTokens.filter(
          (accessToken) => accessToken.id != accessTokenId
        );
        that.setState({ accessTokens: accessTokens });
        toastr.success("Access Token Deleted");
      })
      .catch(function (error) {
        toastr.error("ERROR Access Token Not Deleted");
        console.log(error);
      });
  }

  render() {
    var that = this;

    return (
      <div>
        <h1>DigiQuatics Accounts</h1>
        <div className="row">
          <br className="visible-xs" />
          {!that.state.accessTokenView ? (
            <Search
              newSearchCallback={(newSearch) => this.newSearch(newSearch)}
            />
          ) : (
            <div className="col-md-3 col-xs-12"></div>
          )}
          <div className="col-md-9 col-xs-12">
            <div className="row">
              <div className="col-sm-3 col-xs-6">
                {!that.state.accessTokenView && (
                  <label>
                    <Switch
                      checked={that.state.userOverLimitAccounts}
                      onChange={(event) =>
                        that.handleUserOverLimitAccountFilter(event)
                      }
                      onColor="#DADCE1"
                      onHandleColor="#3A4590"
                      handleDiameter={25}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch center-react-switch"
                    />
                    <span>Over User Limit</span>
                  </label>
                )}
              </div>
              <div className="col-sm-2 col-xs-6">
                {!that.state.accessTokenView && (
                  <label>
                    <Switch
                      checked={that.state.dStarAccounts}
                      onChange={(event) => that.handleDStarAccountFilter(event)}
                      onColor="#DADCE1"
                      onHandleColor="#3A4590"
                      handleDiameter={25}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch center-react-switch"
                    />
                    <span>D-STAR</span>
                  </label>
                )}
              </div>
              <div className="col-sm-2 col-xs-6">
                {!that.state.accessTokenView && (
                  <label>
                    <Switch
                      checked={that.state.showArchived}
                      onChange={(event) => that.handleShowArchivedFilter(event)}
                      onColor="#DADCE1"
                      onHandleColor="#3A4590"
                      handleDiameter={25}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch center-react-switch"
                    />
                    <span>Archived</span>
                  </label>
                )}
              </div>
              <div className="col-sm-5 col-xs-12">
                <div className="pull-right">
                  {!that.state.accessTokenView &&
                    <a
                      className="btn btn-indigo btn-raised margin-right-five"
                      href="/employee_search"
                    >
                      EMPLOYEE SEARCH
                    </a>
                  }
                  {!that.state.accessTokenView && this.props.currentUser.account_id != this.props.digiquaticsAccountId && (
                    <a
                      className="btn btn-pink btn-raised margin-right-five"
                      onClick={function () {
                        that.setAccount();
                      }}
                    >
                      RETURN TO DIGIQUATICS
                    </a>
                  )}
                  {that.state.accessTokenView ? (
                    <a
                      className="btn btn-indigo btn-raised margin-right-five"
                      onClick={function () {
                        that.toggleAccessTokenView();
                      }}
                    >
                      ACCOUNTS
                    </a>
                  ) : (
                    <a
                      className="btn btn-indigo btn-raised margin-right-five"
                      onClick={function () {
                        that.toggleAccessTokenView();
                      }}
                    >
                      TOKENS
                    </a>
                  )}
                  {that.state.accessTokenView && (
                    <a
                      className="btn btn-pink btn-raised margin-right-five"
                      onClick={function () {
                        that.createAccessToken();
                      }}
                    >
                      GENERATE ACCESS TOKEN
                    </a>
                  )}
                  <br className="visible-xs visible-sm" />
                  <br className="visible-xs visible-sm" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {!that.state.accessTokenView ? (
          <div>
            {that.state.accounts.length && !that.state.loading ? (
              <div>
                <table className="table table-clean table-white">
                  <thead>
                    <tr>
                      <th
                        onClick={() => this.sortData("id")}
                        className="hidden-xs hidden-sm"
                      >
                        <a className="styled-link pointer-hand">ID</a>
                      </th>
                      <th onClick={() => this.sortData("name")}>
                        <a className="styled-link pointer-hand">Name</a>
                      </th>
                      <th
                        onClick={() => this.sortData("created_at")}
                        className="hidden-xs hidden-sm"
                      >
                        <a className="styled-link pointer-hand">Created At</a>
                      </th>
                      <th onClick={() => this.sortData("trial")}>
                        <a className="styled-link pointer-hand">Trial</a>
                      </th>
                      <th
                        onClick={() => this.sortData("trial_expires_on")}
                        className="hidden-xs hidden-sm"
                      >
                        <a className="styled-link pointer-hand">Trial Expires</a>
                      </th>
                      <th
                        onClick={() => this.sortData("payment_due_at")}
                        className="hidden-xs hidden-sm"
                      >
                        <a className="styled-link pointer-hand">Payment Due Date</a>
                      </th>
                      <th
                        onClick={() =>
                          this.sortData("remaining_active_users", "ASC")
                        }
                        className="hidden-xs hidden-sm"
                      >
                        <a className="styled-link pointer-hand">Active Users</a>
                      </th>
                      <th className="hidden-xs hidden-sm" />
                      <th />
                      <th />
                    </tr>
                  </thead>
                  {this.renderBody()}
                </table>

                {this.renderPagination()}

                <div className="modal fade" id="editAccountModal">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <h1 className="modal-title">
                          {this.state.selectedAccount.name}
                        </h1>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-xs-12 col-md-6">
                            <label>Expiration Date *</label>
                            <br />
                            <input
                              id="editTrialExpirationDate"
                              className="full-width"
                            />
                          </div>
                          <div className="col-xs-12 col-md-6">
                            <label>Payment Due Date</label>
                            <br />
                            <input id="editPaymentDueDate" className="full-width" />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12 col-md-6">
                            <label>Active User Limit</label>
                            <br />
                            <input
                              id="editActiveUserLimit"
                              className="form-control full-width"
                              value={this.state.activeUserLimit}
                              onChange={(e) =>
                                that.setState({ activeUserLimit: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-xs-12 col-md-6">
                            <label>Jotform URL</label>
                            <br />
                            <input
                              className="form-control full-width"
                              value={this.state.jotformUrl}
                              onChange={(e) =>
                                that.setState({ jotformUrl: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Scheduling Module"}
                          toggleValue={that.state.schedulingToggle}
                          toggleName={"schedulingToggle"}
                          expirationDateName={"editSchedulingModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Time Clocks Module"}
                          toggleValue={that.state.timeClocksToggle}
                          toggleName={"timeClocksToggle"}
                          expirationDateName={"editTimeClocksModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Certifications Module"}
                          toggleValue={that.state.certificationsToggle}
                          toggleName={"certificationsToggle"}
                          expirationDateName={"editCertificationsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"In-Service Module"}
                          toggleValue={that.state.inServicesToggle}
                          toggleName={"inServicesToggle"}
                          expirationDateName={"editinServicesModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Shift Reports Module"}
                          toggleValue={that.state.shiftReportsToggle}
                          toggleName={"shiftReportsToggle"}
                          expirationDateName={"editShiftReportsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Custom Forms Module"}
                          toggleValue={that.state.customFormsToggle}
                          toggleName={"customFormsToggle"}
                          expirationDateName={"editCustomFormsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Checklist Module"}
                          toggleValue={that.state.checklistsToggle}
                          toggleName={"checklistsToggle"}
                          expirationDateName={"editchecklistsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Chemical Records Module"}
                          toggleValue={that.state.chemicalRecordsToggle}
                          toggleName={"chemicalRecordsToggle"}
                          expirationDateName={"editChemicalRecordsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Feature Inspection Module"}
                          toggleValue={that.state.slideInspectionsToggle}
                          toggleName={"slideInspectionsToggle"}
                          expirationDateName={"editslideInspectionsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Patron Counts Module"}
                          toggleValue={that.state.patronCountsToggle}
                          toggleName={"patronCountsToggle"}
                          expirationDateName={"editPatronCountsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Lesson Requests Module"}
                          toggleValue={that.state.privateLessonsToggle}
                          toggleName={"privateLessonsToggle"}
                          expirationDateName={"editprivateLessonsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Group Lessons Module"}
                          toggleValue={that.state.groupLessonsToggle}
                          toggleName={"groupLessonsToggle"}
                          expirationDateName={"editGroupLessonsModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Member Management Module"}
                          toggleValue={that.state.memberManagementToggle}
                          toggleName={"memberManagementToggle"}
                          expirationDateName={"editMemberManagementModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <ModuleToggleAndExpirationDate
                          title={"Digichat Module"}
                          toggleValue={that.state.digichatToggle}
                          toggleName={"digichatToggle"}
                          expirationDateName={"editDigichatModuleExpDate"}
                          toggleColumn={that.toggleColumn}
                        />
                        <br />

                        <h4>D-STAR Programs</h4>
                        <label>Starfish Program Toggle</label>
                        <br />
                        <Switch
                          checked={that.state.showStarfishProgram}
                          onChange={(e) =>
                            that.toggleColumn(e, "showStarfishProgram")
                          }
                          onColor="#DADCE1"
                          onHandleColor="#3A4590"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={20}
                          width={48}
                          className="react-switch"
                          id="material-switch"
                        />
                        <br />

                        <label>PADI Program Toggle</label>
                        <br />
                        <Switch
                          checked={that.state.showPadiProgram}
                          onChange={(e) => that.toggleColumn(e, "showPadiProgram")}
                          onColor="#DADCE1"
                          onHandleColor="#3A4590"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={20}
                          width={48}
                          className="react-switch"
                          id="material-switch"
                        />
                        <br />

                        <label>SAI Account</label>
                        <br />
                        <Switch
                          checked={that.state.isSai}
                          onChange={(e) => that.toggleColumn(e, "isSai")}
                          onColor="#DADCE1"
                          onHandleColor="#3A4590"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={20}
                          width={48}
                          className="react-switch"
                          id="material-switch"
                        />
                        <br />
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-pink full-width"
                          onClick={function () {
                            that.saveAccount();
                          }}
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loading loading={this.state.loading} noDataMessage="No accounts" />
            )}
          </div>
        ) : (
          <br />
        )}
        {(that.state.accessTokenView && that.state.accessTokens.length > 0) &&
          <table className="table table-clean table-white">
            <thead>
              <tr>
                <th>DATE CREATED</th>
                <th>TOKEN</th>
                <th>LAST USED</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {that.state.accessTokens.map((accessToken) => (
                <tr key={accessToken.id}>
                  <DateTd
                    fieldValue={accessToken.created_at}
                    fieldFormat="M/D/YYYY hh:mm"
                  />
                  <GeneralTd fieldValue={accessToken.token} />
                  <DateTd
                    fieldValue={accessToken.updated_at}
                    fieldFormat="M/D/YYYY hh:mm"
                  />
                  <td>
                    <a className="btn btn-text pull-right"
                      href={accessToken.standard_link}
                    >
                      STANDARD LINK
                    </a>
                  </td>
                  <td>
                    <a className="btn btn-text pull-right"
                      href={accessToken.starfish_link}
                    >
                      STARFISH LINK
                    </a>
                  </td>
                  <td>
                    <a className="btn btn-text pull-right"
                      href={accessToken.padi_link}
                    >
                      PADI LINK
                    </a>
                  </td>
                  <td>
                    <a className="btn btn-text pull-right"
                      onClick={function () {
                        that.destroyAccessToken(accessToken.id);
                      }}
                    >
                      DELETE
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        }
      </div>
    );
  }
}

Admin.propTypes = {
  current_user: PropTypes.object,
};

export default Admin;
